const features = [
  {
    number: '01',
    title: '自社実績に基づいたマッチング',
    description:
      'atcoは、これまで多くの企業様とのマッチング実績があります。その経験から、企業様と人材の双方にとって最適なマッチングを実現するノウハウを蓄積してきました。豊富な実績に基づいたマッチングで、お客様のビジネスを成功に導きます。',
  },
  {
    number: '02',
    title: '高い専門性',
    description:
      'atcoのマッチング担当者は、IT業界や経理業界の専門知識と経験を持つプロフェッショナルです。お客様のニーズを深く理解し、最適な人材を紹介いたします。',
  },
  {
    number: '03',
    title: '透明性の高い料金体系',
    description:
      'atcoの料金体系は、明確でわかりやすく、安心してサービスをご利用いただけます。成功報酬型のプランもご用意しており、お客様の成功を第一に考えます。',
  },
  {
    number: '04',
    title: '充実したサポート体制',
    description:
      'マッチング後も、お客様と人材の双方をサポートいたします。定期的な面談やフォローアップを通じて、スムーズな業務遂行を支援いたします。',
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Features</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">サービスの特徴</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {features.map((feature) => (
            <div key={feature.number} className="flex gap-5">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#3d6b4f] text-white text-sm font-bold rounded-md">
                {feature.number}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
